import { DocumentsFiltersState } from '@app/features/documents/hooks/useDocumentsFilter';
import SearchType from '@app/store/documents/SearchType';
import StatusFilter from '@app/store/documents/StatusFilter';

const INITIAL_FILTER_VALUES: DocumentsFiltersState = {
  assigned: 'SELF',
  groupId: null,
  isArchived: false,
  labelId: undefined,
  limit: 10,
  offset: 0,
  sort: 'updatedAt:desc',
  searchKeyword: '',
  searchType: SearchType.TITLE,
  status: StatusFilter.ALL,
  dateFilterType: 'UPDATED_AT',
  dateRangeFrom: null,
  dateRangeTo: null,
};

export default INITIAL_FILTER_VALUES;
